import { Injectable } from '@angular/core';
import { ZalacznikWiadomosciDto } from '@interfaces/komunikacja/komunikacja.interface';
import { UsunWiadomoscWyslanaRequest, WiadomoscWyslanaDto } from '@interfaces/komunikacja/wiadomosc-wyslana.interface';
import { PageQueryParams, ParamsInterface } from '@interfaces/params.interface';
import { IPaginatedData } from '@interfaces/response.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WiadomosciWyslaneService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/komunikacja/wiadomosci/wiadomosci-wyslane`;

  getRecord(id: string): Observable<WiadomoscWyslanaDto> {
    return this.http.get<WiadomoscWyslanaDto>(`${this.endpoint}/${id}`);
  }

  getRecords(queryParams?: ParamsInterface): Observable<IPaginatedData<WiadomoscWyslanaDto>> {
    return this.http.get<IPaginatedData<WiadomoscWyslanaDto>>(this.endpoint, {
      params: this.createQueryParams(queryParams),
    });
  }

  getAttachments(id: string, params?: PageQueryParams): Observable<IPaginatedData<ZalacznikWiadomosciDto>> {
    return this.http.get<IPaginatedData<ZalacznikWiadomosciDto>>(`${this.endpoint}/${id}/zalaczniki`, {
      params: this.createQueryParams(params),
    });
  }

  getAttachment(id: string, attachmentId: string): Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>(`${this.endpoint}/${id}/zalaczniki/${attachmentId}`, {
      responseType: 'arraybuffer' as 'json',
    });
  }

  delete(body: UsunWiadomoscWyslanaRequest): Observable<null> {
    return this.http.delete<null>(`${this.endpoint}`, { body });
  }
}
